import { createContext, useState } from 'react';

export interface SelectNameCtxContextProps {
  selectNameCtx: string;
  setSelectCtxName: (option: any) => void;
}

export const SelectNameContext = createContext<SelectNameCtxContextProps>({
  selectNameCtx: '',
  setSelectCtxName: () => { }
})

export function SelectNameProvider(props: { children: React.ReactNode }) {
  const [selectNameCtx, setSelectCtxName] = useState<string>('');

  return (
    <SelectNameContext.Provider value={{ selectNameCtx, setSelectCtxName }}>
      {props.children}
    </SelectNameContext.Provider>
  )
}